import type { FC, ReactNode } from 'react'

interface PunctuatedTextProps {
    text: string
}

const TRAILING_PUNCTUATION = /[.!?]+$/

// Renders copy as written, with its closing punctuation picked out in the accent red.
const PunctuatedText: FC<PunctuatedTextProps> = ({ text }): ReactNode => {
    const punctuation = text.match(TRAILING_PUNCTUATION)?.[0]

    if (!punctuation) return text

    return (
        <>
            {text.slice(0, -punctuation.length)}
            <span className='text-primary'>
                {punctuation}
            </span>
        </>
    )
}

export default PunctuatedText
